import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import DisiApi from "datas/disi/DisiApi";
import ConstantsResult from "domains/entity/main/ConstantResult";
import PettyCashUseCase from "domains/interactor/main/disi/PettyCash";
import { RootState } from "utils/store";

type iState = {
    data: ConstantsResult;
    loading: boolean;
    error: any;
}

const initialState: iState = {
    data: [],
    loading: false,
    error: ""
}

export const pettyCashTypeAction = createAsyncThunk('petty-cash-type-action', async (_, { getState, rejectWithValue }) => {
    try {
        const rootState = getState() as RootState
        const { data } = rootState.main.disi.pettyCashType

        if (data.length) {
            return Promise.resolve(data)
        }

        const useCase = new PettyCashUseCase(new DisiApi())

        return await useCase.getPettyCashType()
    } catch (error) {
        const { response } = error;
        if (!response) {
            throw error
        }
        return rejectWithValue(response.data)
    }
})

const pettyCashTypeSlice = createSlice({
    name: "petty-cash-type-slice",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(pettyCashTypeAction.pending, state => {
            state.loading = true;
            state.error = ""
        })
        builder.addCase(pettyCashTypeAction.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload
            state.error = ""
        })
        builder.addCase(pettyCashTypeAction.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

const pettyCashTypeReducer = pettyCashTypeSlice.reducer

export default pettyCashTypeReducer 